/** Vite `base` always has a trailing slash (`/` or `/carvoeiro-nav-mock/app/`). */

export function viteBase(): string {
  const raw = import.meta.env.BASE_URL || '/';
  if (raw === './') return './';
  return raw.endsWith('/') ? raw : `${raw}/`;
}

/** React Router basename: no trailing slash. Empty string at domain root. */
export function routerBasename(): string {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname;
    const gh = '/carvoeiro-nav-mock/app';
    if (path === gh || path.startsWith(`${gh}/`)) return gh;
  }
  const raw = import.meta.env.BASE_URL || '/';
  if (!raw || raw === '/' || raw === './') return '';
  return raw.replace(/\/$/, '');
}

export function withBase(path: string): string {
  const trimmed = path.replace(/^\//, '');
  if (typeof window !== 'undefined') {
    const gh = '/carvoeiro-nav-mock/app';
    if (window.location.pathname === gh || window.location.pathname.startsWith(`${gh}/`)) {
      return `${gh}/${trimmed}`;
    }
  }
  const base = viteBase();
  if (base === './') return trimmed;
  return `${base}${trimmed}`;
}
